import {Span} from '../../search/search-types';
import {SpanHighlight} from './PdfViewer.types';
import {hasPdfCoordinates} from './spanMath';

/**
 * Turns the query hits the server returned into highlights, in the same form as the tag highlights built
 * in tagHighlights.ts. The server gives every query hit a page and a position, so the hasPdfCoordinates
 * filter should never remove one. It is only a safety check, the same one the tag highlights use.
 *
 * The server sends the hits sorted by page, and within a page by their position on it. Opening on the
 * first hit, the hit counter and the next/previous buttons all follow this order, so the list is not
 * sorted again here.
 */
export function buildQueryHighlights(querySpans: Span[] | undefined): SpanHighlight[] {
    if (!querySpans?.length) {
        return [];
    }
    return querySpans.filter(hasPdfCoordinates).map((span, i) => ({
        id: `query#${i}`,
        page: span.pageNumber,
        subtype: 'Highlight',
        rect: [
            span.bottomLeftX,
            span.bottomLeftY,
            span.bottomLeftX + span.width,
            span.bottomLeftY + span.height,
        ],
        rotation: 0,
        color: new Uint8ClampedArray([255, 255, 102]),
        annotationType: 0,
        contentsObj: {str: 'HIBU query term', dir: 'ltr'},
        titleObj: {str: '', dir: 'ltr'},
        span,
    }));
}
